export function compararNomeNatural(a, b) {
    return String((a && a.nome) || '').localeCompare(String((b && b.nome) || ''), 'pt-BR', { numeric: true, sensitivity: 'base' });
}

export function ordenarPorNome(lista) {
    return (lista || []).slice().sort(compararNomeNatural);
}
